export class vn_app_zone_notification {
    static { this.TYPE_SUCCESS = "success"; }
    static { this.TYPE_WARNING = "alert"; }
    static { this.TYPE_ERROR = "error"; }
    constructor(type, message) {
        this.type = type;
        this.message = message;
    }
    get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
    }
    get message() {
        return this._message;
    }
    set message(message) {
        this._message = message;
    }
}
